import { t } from '@lingui/core/macro';
export function makeTableCellConfig(name, options) {
    const config = {
        action: {
            id: 'action',
            label: undefined,
            disabled: true,
            sortable: false,
            active: false,
        },
        name: {
            id: 'name',
            label: t({ message: 'Title', comment: 'Search table column header' }),
            disabled: false,
            sortable: true,
            active: false,
        },
        entityId: {
            id: 'entityId',
            label: t({ message: 'Contract ID', comment: 'Search table column header' }),
            disabled: false,
            sortable: false,
            active: false,
        },
        entityType: {
            id: 'entityType',
            label: t({ message: 'Type', comment: 'Search table column header' }),
            disabled: false,
            sortable: false,
            active: false,
        },
        categoryId: {
            id: 'categoryId',
            label: t({ message: 'Template category', comment: 'Search table column header' }),
            disabled: false,
            sortable: false,
            active: false,
        },
        createdAt: {
            id: 'createdAt',
            label: t({ message: 'Created at', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        updatedAt: {
            id: 'updatedAt',
            label: t({ message: 'Updated at', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        createdByUser: {
            id: 'createdByUser',
            label: t({ message: 'Created by', comment: 'Search table column header' }),
            sortable: false,
            active: false,
        },
        metadataDocumentDocumentType: {
            id: 'metadataDocumentDocumentType',
            label: t({ message: 'Document type', comment: 'Search table column header' }),
            sortable: false,
            active: false,
        },
        metadataDocumentMaterialAgreement: {
            id: 'metadataDocumentMaterialAgreement',
            label: t({ message: 'Material agreement', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentTerminationDate: {
            id: 'metadataDocumentTerminationDate',
            label: t({ message: 'Termination date', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentNoticeDate: {
            id: 'metadataDocumentNoticeDate',
            label: t({ message: 'Notice date', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentDateSigned: {
            id: 'metadataDocumentDateSigned',
            label: t({ message: 'Date signed', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentActive: {
            id: 'metadataDocumentActive',
            label: t({ message: 'Active', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentEsigningStatus: {
            id: 'metadataDocumentEsigningStatus',
            label: t({ message: 'eSigning status', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentIsSharedExternally: {
            id: 'metadataDocumentIsSharedExternally',
            label: t({ message: 'Shared externally', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentAutomaticRenewal: {
            id: 'metadataDocumentAutomaticRenewal',
            label: t({ message: 'Automatic renewal', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentContractOwner: {
            id: 'metadataDocumentContractOwner',
            label: t({ message: 'Contract owner', comment: 'Search table column header' }),
            sortable: false,
            active: false,
        },
        metadataDocumentCountry: {
            id: 'metadataDocumentCountry',
            label: t({ message: 'Country', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentCurrency: {
            id: 'metadataDocumentCurrency',
            label: t({ message: 'Currency', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentDeviateFromStandard: {
            id: 'metadataDocumentDeviateFromStandard',
            label: t({ message: 'Deviate from standard', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentGoverningLaw: {
            id: 'metadataDocumentGoverningLaw',
            label: t({ message: 'Governing law', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentNotes: {
            id: 'metadataDocumentNotes',
            label: t({ message: 'Notes', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentNoticePeriodMonths: {
            id: 'metadataDocumentNoticePeriodMonths',
            label: t({ message: 'Notice period months', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentOriginalTermMonths: {
            id: 'metadataDocumentOriginalTermMonths',
            label: t({ message: 'Original term months', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentRenewalTermMonths: {
            id: 'metadataDocumentRenewalTermMonths',
            label: t({ message: 'Renewal term months', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentTotalContractCost: {
            id: 'metadataDocumentTotalContractCost',
            label: t({ message: 'Total contract cost', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentTotalContractValue: {
            id: 'metadataDocumentTotalContractValue',
            label: t({ message: 'Total contract value', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentStartDate: {
            id: 'metadataDocumentStartDate',
            label: t({ message: 'Start date', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentProcessingOfPersonalData: {
            id: 'metadataDocumentProcessingOfPersonalData',
            label: t({ message: 'Processing of personal data', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentOriginalVersionStored: {
            id: 'metadataDocumentOriginalVersionStored',
            label: t({ message: 'Original version stored', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentOutsourcing: {
            id: 'metadataDocumentOutsourcing',
            label: t({ message: 'Outsourcing', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentDocumentCategory: {
            id: 'metadataDocumentDocumentCategory',
            label: t({ message: 'Document category', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentNoticePeriodDays: {
            id: 'metadataDocumentNoticePeriodDays',
            label: t({ message: 'Notice period days', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentStatus: {
            id: 'metadataDocumentStatus',
            label: t({ message: 'Status', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentType: {
            id: 'metadataDocumentType',
            label: t({ message: 'Type', comment: 'Search table column header' }),
            sortable: false,
            active: false,
        },
        metadataDocumentDiscount: {
            id: 'metadataDocumentDiscount',
            label: t({ message: 'Discount', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentFeeAdjustmentClause: {
            id: 'metadataDocumentFeeAdjustmentClause',
            label: t({ message: 'Fee Adjustment Clause', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentIndemnity: {
            id: 'metadataDocumentIndemnity',
            label: t({ message: 'Indemnity', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentLiabilityCap: {
            id: 'metadataDocumentLiabilityCap',
            label: t({ message: 'Liability Cap', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentLiabilityCapScope: {
            id: 'metadataDocumentLiabilityCapScope',
            label: t({ message: 'Liability Cap Scope', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentLimitationOfLiability: {
            id: 'metadataDocumentLimitationOfLiability',
            label: t({ message: 'Limitation Of Liability', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentPaymentTermsDaysFromInvoiceDate: {
            id: 'metadataDocumentPaymentTermsDaysFromInvoiceDate',
            label: t({
                message: 'Payment Terms Days From Invoice Date',
                comment: 'Search table column header',
            }),
            sortable: true,
            active: false,
        },
        metadataDocumentPostTerminationObligations: {
            id: 'metadataDocumentPostTerminationObligations',
            label: t({
                message: 'Post Termination Obligations',
                comment: 'Search table column header',
            }),
            sortable: true,
            active: false,
        },
        metadataDocumentProbationaryPeriod: {
            id: 'metadataDocumentProbationaryPeriod',
            label: t({ message: 'Probationary Period', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentProbationaryPeriodExpirationDate: {
            id: 'metadataDocumentProbationaryPeriodExpirationDate',
            label: t({
                message: 'Probationary Period Expiration Date',
                comment: 'Search table column header',
            }),
            sortable: true,
            active: false,
        },
        metadataDocumentTerminationForCause: {
            id: 'metadataDocumentTerminationForCause',
            label: t({ message: 'Termination For Cause', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentTerminationForConvenience: {
            id: 'metadataDocumentTerminationForConvenience',
            label: t({ message: 'Termination For Convenience', comment: 'Search table column header' }),
            sortable: true,
            active: false,
        },
        metadataDocumentParties: {
            id: 'metadataDocumentParties',
            label: t({ message: 'Parties', comment: 'Search table column header' }),
            sortable: false,
            active: false,
        },
        metadataDocumentProjectIds: {
            id: 'metadataDocumentProjectIds',
            label: t({ message: 'Projects', comment: 'Search table column header' }),
            sortable: false,
            active: false,
        },
        metadataProjectCustomerId: {
            id: 'metadataProjectCustomerId',
            label: t({ message: 'Project ID', comment: 'Search table column header for projects project id' }),
            sortable: true,
            active: false,
        },
        metadataProjectDocumentsCount: {
            id: 'metadataProjectDocumentsCount',
            label: t({ message: 'Documents', comment: 'Search table column header for projects document count' }),
            sortable: true,
            active: false,
        },
        metadataProjectMembersUserIds: {
            id: 'metadataProjectMembersUserIds',
            label: t({ message: 'Users', comment: 'Search table column header for projects users' }),
            sortable: false,
            active: false,
        },
        metadataProjectMembersTeamIds: {
            id: 'metadataProjectMembersTeamIds',
            label: t({ message: 'Teams', comment: 'Search table column header for projects teams' }),
            sortable: false,
            active: false,
        },
        metadataProjectMembersCombinedUserIds: {
            id: 'metadataProjectMembersCombinedUserIds',
            label: t({ message: 'Members', comment: 'Search table column header for projects members' }),
            sortable: false,
            active: false,
        },
        metadataProjectStatus: {
            id: 'metadataProjectStatus',
            label: t({ message: 'Status', comment: 'Search table column header for projects status' }),
            sortable: true,
            active: false,
        },
        metadataProjectContractTerm: {
            id: 'metadataProjectContractTerm',
            label: t({ message: 'Contract term', comment: 'Search table column header for projects contract term' }),
            sortable: true,
            active: false,
        },
        metadataProjectProjectOwner: {
            id: 'metadataProjectProjectOwner',
            label: t({ message: 'Project owner', comment: 'Search table column header for projects project owner' }),
            sortable: true,
            active: false,
        },
        metadataDocumentContractRole: {
            id: 'metadataDocumentContractRole',
            label: t({ message: 'Contract role', comment: 'Search table column header for contract role' }),
            sortable: true,
            active: false,
        },
        metadataDocumentMarketingTrademarkUse: {
            id: 'metadataDocumentMarketingTrademarkUse',
            label: t({
                message: 'Marketing trademark use',
                comment: 'Search table column header for marketing trademark use',
            }),
            sortable: true,
            active: false,
        },
    };
    const commonConfig = config[name];
    if (commonConfig) {
        return Object.assign(Object.assign({}, commonConfig), options);
    }
    return Object.assign({ id: name, label: t({ message: 'Unknown', comment: 'Search table column header for unknown column' }), disabled: false, sortable: false, active: false }, options);
}
